/**
 * DemoOfferPreviewPopup
 *
 * "Oferecer" num item de exemplo da lista de espera (trial-demo-data): mostra a
 * mensagem que sairia pelo WhatsApp, sem enviar nada nem registrar oferta.
 */
import React from 'react';
import { Alert } from '@mui/material';
import PopupBase from '../../../popup/base/PopupBase';
import CustomButton from '../../../components/buttons/CustomButton';
import styles from '../WaitingListV2Page.module.css';

/** Linha da mensagem com o negrito do WhatsApp (*texto*) aplicado. */
function MessageLine({ line }) {
  const parts = line.split(/(\*[^*\n]+\*)/g).filter(Boolean);
  return (
    <p className={styles.demoPreviewLine}>
      {parts.length === 0 ? ' ' : parts.map((part, i) => (
        part.startsWith('*') && part.endsWith('*') && part.length > 2
          ? <strong key={i}>{part.slice(1, -1)}</strong>
          : <React.Fragment key={i}>{part}</React.Fragment>
      ))}
    </p>
  );
}

function DemoOfferPreviewPopup({ preview, onClose }) {
  if (!preview) return null;

  const content = (
    <div className={styles.demoPreviewContent}>
      <Alert severity="info">
        Nos exemplos nada é enviado. Esta é a mensagem que {preview.name || 'a pessoa'} receberia
        pelo WhatsApp ao oferecer o horário.
      </Alert>
      <div className={styles.demoPreviewChat}>
        <div className={styles.demoPreviewBubble}>
          {String(preview.message || '').split(/\r?\n/).map((line, i) => (
            <MessageLine key={i} line={line} />
          ))}
        </div>
      </div>
    </div>
  );

  const footer = (
    <div style={{ display: 'flex', width: '100%', justifyContent: 'flex-end' }}>
      <CustomButton variant="contained" style="primary" label="Entendi" onClick={onClose} />
    </div>
  );

  return (
    <PopupBase
      Title="Prévia da oferta"
      Content={content}
      Footer={footer}
      OnClose={onClose}
      maxWidth="sm"
    />
  );
}

export default DemoOfferPreviewPopup;
